<template>
    <div class="buttons-wrap" :class="{ active: active }">

        <div>
            <a id="attachment"
               v-if="attachmentLink !== ''"
               :href="attachmentLink "
                target="_blank">
              <simple-svg
                :filepath="this.getSvgFilePath('attachment')"
                width="20px"
                height="20px"
              ></simple-svg>
            </a>
            <b-tooltip target="attachment" placement="bottom" triggers="hover">
                Attachment
            </b-tooltip>
        </div>

        <sc-more-info-share-widget
            :sermon="sermon"
        >
        </sc-more-info-share-widget>

        <sc-more-info-download-widget v-if="isStreaming"
            :sermon="sermon"
        ></sc-more-info-download-widget>



    </div>
</template>
<script>
import scMoreInfoDownloadWidget from './scMoreInfoDownloadWidget.vue'
import ScMoreInfoShareWidget from './scMoreInfoShareWidget.vue'
import BTooltip from 'bootstrap-vue/es/components/tooltip/tooltip'


export default {
  components: { scMoreInfoDownloadWidget, ScMoreInfoShareWidget, BTooltip },
    props: ['sermon','isStreaming'],
    data() {
        return {
            active: true
        }
    },
    watch: {
        sermon: function() {
            this.active = false
        }
    },
    computed: {
        attachmentLink() {
            if (this.sermon &&
                this.sermon.document &&
                this.sermon.document.url)
            {
                return this.sermon.document.url
            }
            return '';
        }
    }
}
</script>
<style lang="scss" scoped>
.buttons-wrap {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: flex-start;
    margin-right: 15px;
    width: auto;
    margin-right: 15px;
    gap: 15px;
    &.active {
        flex-direction: row;
    }
}
</style>
